import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "print-only-container" }
const _hoisted_2 = {
  class: "receipt-container",
  id: "printable-receipt"
}
const _hoisted_3 = { class: "receipt-header text-center mb-20" }
const _hoisted_4 = { class: "fw-bold mb-1" }
const _hoisted_5 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_7 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_8 = { class: "receipt-info mb-20" }
const _hoisted_9 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_10 = { class: "fw-bold" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-content-between mb-1"
}
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = { class: "fw-bold" }
const _hoisted_15 = { class: "d-flex justify-content-between" }
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = {
  key: 1,
  class: "text-center mt-2 small text-muted"
}
const _hoisted_18 = { class: "table receipt-table mb-20" }
const _hoisted_19 = { class: "ps-0" }
const _hoisted_20 = { class: "text-center fw-bold" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-end pe-0 fw-bold" }
const _hoisted_23 = { class: "receipt-totals mb-20" }
const _hoisted_24 = { class: "d-flex justify-content-between mb-1 border-top pt-2" }
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex justify-content-between mb-1"
}
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "fw-bold text-danger" }
const _hoisted_30 = {
  key: 1,
  class: "d-flex justify-content-between mb-1"
}
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "fw-bold text-danger" }
const _hoisted_33 = {
  key: 2,
  class: "d-flex justify-content-between mb-1"
}
const _hoisted_34 = { class: "fw-bold" }
const _hoisted_35 = { class: "fw-bold" }
const _hoisted_36 = {
  key: 3,
  class: "d-flex justify-content-between mb-1"
}
const _hoisted_37 = { class: "fw-bold" }
const _hoisted_38 = { class: "fw-bold" }
const _hoisted_39 = { class: "d-flex justify-content-between mb-1 border-top pt-2" }
const _hoisted_40 = { class: "fw-bold fs-16" }
const _hoisted_41 = { class: "fw-bold fs-16" }
const _hoisted_42 = { class: "d-flex justify-content-between" }
const _hoisted_43 = { class: "fw-bold" }
const _hoisted_44 = { class: "fw-bold text-uppercase" }
const _hoisted_45 = { class: "receipt-footer text-center mt-40 pt-20 border-top" }
const _hoisted_46 = {
  key: 0,
  class: "mb-1 fw-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.stateStore.siteName), 1),
        (_ctx.stateStore.receiptSettings.showAddress && _ctx.stateStore.companyAddress)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.stateStore.companyAddress), 1))
          : _createCommentVNode("", true),
        (_ctx.stateStore.receiptSettings.showPhone && _ctx.stateStore.companyPhone)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.stateStore.companyPhone), 1))
          : _createCommentVNode("", true),
        (_ctx.stateStore.receiptSettings.showEmail && _ctx.stateStore.companyEmail)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.stateStore.companyEmail), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("sales_page.date")) + ":", 1)
          ]),
          _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.sale.date || _ctx.sale.created_at)), 1)
        ]),
        (_ctx.stateStore.receiptSettings.showCustomer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("sales_page.customer")) + ":", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.sale.customer_name || _ctx.sale.customer?.name || _ctx.$t("sales_page.walk_in_customer")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("sales_page.reference_short")) + ":", 1)
          ]),
          _createElementVNode("div", null, _toDisplayString(_ctx.sale.reference_no), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("sales_page.warehouse")) + ":", 1)
          ]),
          _createElementVNode("div", null, _toDisplayString(_ctx.sale.warehouse_name || _ctx.sale.warehouse?.name || _ctx.$t("sales_page.not_available_short")), 1)
        ]),
        (_ctx.stateStore.receiptSettings.showBarcode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.sale.reference_no), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("table", _hoisted_18, [
        _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "ps-0" }, [
              _createTextVNode(" មុខទំនិញ "),
              _createElementVNode("br"),
              _createTextVNode(" Descriptions ")
            ]),
            _createElementVNode("th", { class: "text-center" }, [
              _createTextVNode(" ចំនួន "),
              _createElementVNode("br"),
              _createTextVNode(" Quantity ")
            ]),
            _createElementVNode("th", { class: "text-end" }, [
              _createTextVNode(" តម្លៃ "),
              _createElementVNode("br"),
              _createTextVNode(" Price ")
            ]),
            _createElementVNode("th", { class: "text-end pe-0" }, [
              _createTextVNode(" តម្លៃសរុប "),
              _createElementVNode("br"),
              _createTextVNode(" Total ")
            ])
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sale.items, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              _createElementVNode("td", _hoisted_19, _toDisplayString(item.product_name), 1),
              _createElementVNode("td", _hoisted_20, _toDisplayString(item.quantity), 1),
              _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.stateStore.formatPrice(Number(item.unit_price))), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.stateStore.formatPrice(Number(item.total))), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("sales_page.subtotal")) + ":", 1),
          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.stateStore.formatPrice(Number(_ctx.sale.total))), 1)
        ]),
        (_ctx.stateStore.receiptSettings.showTaxDiscount && _ctx.sale.discount && _ctx.sale.discount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("sales_page.discount")) + ":", 1),
              _createElementVNode("span", _hoisted_29, "-" + _toDisplayString(_ctx.sale.discount <= 100 && _ctx.sale.discount_type === 'percentage' ? Number(_ctx.sale.discount) + '%' : _ctx.stateStore.formatPrice(Number(_ctx.sale.discount))), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.stateStore.receiptSettings.showTaxDiscount && _ctx.sale.coupon_discount && _ctx.sale.coupon_discount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("sales_page.coupon")) + ":", 1),
              _createElementVNode("span", _hoisted_32, "-" + _toDisplayString(_ctx.sale.coupon_discount <= 100 && _ctx.sale.coupon_type === 'percentage' ? Number(_ctx.sale.coupon_discount) + '%' : _ctx.stateStore.formatPrice(Number(_ctx.sale.coupon_discount))), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.stateStore.receiptSettings.showTaxDiscount && _ctx.sale.tax && _ctx.sale.tax > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("sales_page.tax")) + ":", 1),
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.stateStore.formatPrice(Number(_ctx.sale.tax))), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.stateStore.receiptSettings.showTaxDiscount && _ctx.sale.shipping && _ctx.sale.shipping > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("sales_page.shipping")) + ":", 1),
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.stateStore.formatPrice(Number(_ctx.sale.shipping))), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("sales_page.grand_total")) + ":", 1),
          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.stateStore.formatPrice(Number(_ctx.sale.grand_total))), 1)
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("sales_page.payment_method")) + ":", 1),
          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.sale.paid_by || _ctx.$t("sales_page.cash")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        (_ctx.stateStore.receiptSettings.showNoteToCustomer)
          ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.stateStore.receiptSettings.noteToCustomer), 1))
          : _createCommentVNode("", true),
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-muted small" }, "Powered by ProCare Digital Marketing", -1))
      ])
    ])
  ]))
}